export default "__VITE_ASSET__CtjLHVv7__"